import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App.tsx";

import {register} from "@public-ui/components";
import {defineCustomElements} from "@public-ui/components/loader";
import {customTheme} from "./_theme.ts";

import "./index.scss";
import {initI18n} from "@/lib/i18n/index.ts";

const main = async () => {
    await register(customTheme, defineCustomElements);
    await initI18n();


    createRoot(document.getElementById("root") as HTMLElement).render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>,
    );
}

main().catch(console.error);